// extracted by mini-css-extract-plugin
export default {"container":"Table_container__vN1lQ","addImg":"Table_addImg__GV6jw"};